// extracted by mini-css-extract-plugin
export default {"password-validator":"hOXL9","validator-tip":"jgNBP","success":"yuf1m","dot":"OMpPU"};